export type FAQColor = "orange" | "blue"

export const FAQColors = {
   orange: {
      text: "text-orange-900",
      border: "group-hover:border-orange-500",
      iconPlus: "group-hover:text-orange-500",
   },
   blue: {
      text: "text-blue-900",
      border: "group-hover:border-blue-500",
      iconPlus: "group-hover:text-blue-500",
   },
}
export interface FAQItem {
   question: string
   answer: string
}

export interface FAQProps {
   items: FAQItem[]
   color?: FAQColor
   title?: string
   subtitle?: string
}

export interface FAQItemRowProps {
   question: string
   answer: string
   isOpen: boolean
   toggle: () => void
   isLast: boolean
   styles: {
      text: string
      iconPlus: string
      border: string
   }
}
